module.exports = __webpack_public_path__ + "static/media/sectur01.1f11efe8.png";